// src/components/Header.js
import Link from "next/link";
import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import { Offcanvas, Button } from 'react-bootstrap';

import Image from 'next/image';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';
export default function Header() {

    const [showdata2, setShowdata2] = useState(false)

    

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [show1, setShow1] = useState(false);

    const handleClose1 = () => setShow1(false);
    const handleShow1 = () => setShow1(true);
    const [inputFormat, setInputFormat] = useState('en');



    useEffect(() => {
        const currentLanguage = localStorage.getItem('language');
        if (!!currentLanguage) {
            setInputFormat(currentLanguage);
        }
        else {
            localStorage.setItem('language', 'en');
        }
    }, [])

    // const handleLang = (lang) => {
    //   setInputFormat(lang);
    //   localStorage.setItem('language', lang)
    //   var languageSelect = document.querySelector("select.goog-te-combo");
    //   languageSelect.value = lang;
    //   languageSelect.dispatchEvent(new Event("change"));
    // }

    // const googleTranslateElementInit = () => {
    //   console.log( localStorage.getItem('language'))
    //   new window.google.translate.TranslateElement(
    //     {
    //       pageLanguage: localStorage.getItem('language'),
    //       autoDisplay: true

    //     },
    //     "google_translate_element"
    //   );
    // };

    // useEffect(() => {
    //   var addScript = document.createElement("script");
    //   addScript.setAttribute(dfsfs
    //     "src",
    //     "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
    //   );
    //   addScript.setAttribute("style", "visibility:hidden !important",);
    //   addScript.setAttribute("type", "text/javascript");
    //   document.body.appendChild(addScript);
    //   window.googleTranslateElementInit = googleTranslateElementInit;

    // }, [inputFormat]);

    const handlelangChange = (e) => {
        // setTimeout(() => {

        //   window.location.reload();
        // }, 2000)
    };

    return (
        <div>
            <div id="google_translate_element" style={{ visibility: "hidden" }}></div>
            <div className="millanceheader">
                <nav className="navbar navbar-expand-xl navbar-light bg-light d-flex align-items-center justify-content-between">
                    <div className="container">



                        {/* <div
                            className="offcanvas offcanvas-start"
                            tabIndex="-1"
                            id="offcanvasExample"
                            aria-labelledby="offcanvasExampleLabel"
                        >
                            <div className="offcanvas-header">
                                <h5 className="offcanvas-title" id="offcanvasExampleLabel">
                                    Sidebar
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close text-reset"
                                    data-bs-dismiss="offcanvas"
                                    aria-label="Close"
                                ></button>
                            </div>
                            <div className="offcanvas-body">
                                Content goes here...
                            </div>
                        </div> */}


                        <button
                            className="btn btn navbar-toggler border-3 px-2 "
                            type="button"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasExample"
                            aria-controls="offcanvasExample"
                            onClick={() => setShow((pre) => !pre)}
                        >


                            <svg width="30" height="30" viewBox="0 0 24 24" fill="none">
                                <path d="M3 12H15M3 6H21M3 18H21" stroke="#008c80" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                            </svg>
                        </button>
                        <div className="pulse1 d-lg-none d-md-none">
                            <FontAwesomeIcon icon={faBell} />
                            {/* <i className="fa fa-bell"></i> */}
                        </div>
                        <div id="logo">
                            <Link href={"/"} className="navbar-brand d-flex align-items-center ">
                                <img src={'/images/home/millance-logo-text.png'} style={{ height: '100%', width: '150px' }}
                                    className=" img-fluid mx-2" alt="millance-logo"/>
                            </Link>
                        </div>
                        <div
                            className={`offcanvas offcanvas-start-xl ${show && 'show'} bg-light`}
                            tabIndex={-1}
                            id="offcanvasExample"
                            aria-labelledby="offcanvasExampleLabel"
                        >

                            <div className="offcanvas-header">
                                <h5 className="offcanvas-title" id="offcanvasExampleLabel">
                                    <Link
                                        href="/"
                                        className="navbar-brand d-flex align-items-center "
                                    >
                                        <img
                                            src={'/images/home/millance-logo-text.png'}
                                            style={{ width: "150px", height: "100%" }}
                                            alt="logo"
                                            className="img-fluid millilgo mx-2"
                                        />
                                    </Link>
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close text-reset"
                                    data-bs-dismiss="offcanvas"
                                    aria-label="Close"
                                    onClick={() => setShow((pre) => !pre)}
                                ></button>
                            </div>
                            <div className="offcanvas-body">
                                <ul className="navbar-nav  ms-auto mb-2 mt-1 mb-lg-0 me-5">
                                    <li className="nav-item dropdown">
                                        <span
                                            className="nav-link dropdown-toggle"
                                            data-bs-toggle="dropdown"
                                            id="navbarDropdown"
                                            role="button"
                                            aria-expanded="false"
                                        >
                                            For Trader
                                        </span>

                                        <div className="dropdown-menu mainmenus" aria-labelledby="navbarDropdown">
                                            <>
                                                <ul>
                                                    <li>
                                                        <a className="dropdown-item">Open Trade Account</a>
                                                    </li>
                                                    <li>
                                                        <Link href={'/forex-trading-account-types'}
                                                            className="dropdown-item"                            >
                                                            Account Type
                                                        </Link>
                                                    </li>
                                                </ul>
                                                <ul>
                                                    <li>
                                                        <a className="dropdown-item" href="#">
                                                            Analytics
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <Link
                                                            href={'/economic-calendar'}
                                                            className="dropdown-item"
                                                        >
                                                            Economic calendar
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link
                                                            href={'/pip-calculator'}
                                                            className="dropdown-item"
                                                        >
                                                            Trader calculators
                                                        </Link>
                                                    </li>
                                                </ul>
                                                <ul>
                                                    <li>
                                                        <a className="dropdown-item">Assets</a>
                                                    </li>
                                                    <li>
                                                        <Link
                                                            href={'/forex-currency-trading'}
                                                            className="dropdown-item"
                                                        >
                                                            Currency
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </>
                                        </div>
                                    </li>


                                    <li className="nav-item dropdown">
                                        <span
                                            className="nav-link dropdown-toggle"
                                            data-bs-toggle="dropdown"
                                            id="navbarDropdown"
                                            role="button"
                                            aria-expanded="false"
                                        >
                                            For Partners
                                        </span>
                                        <div
                                            className="dropdown-menu mainmenus"
                                            aria-labelledby="navbarDropdown"
                                        >
                                            <ul>
                                                <li className="open-demo-but">
                                                    <a className="dropdown-item" href="#">
                                                        <img
                                                            src={"/images/home/mega-ico2.png"}
                                                            style={{
                                                                width: "100%",
                                                                height: "100%",
                                                                maxWidth: "300px",
                                                            }}
                                                            alt="logo"
                                                            className="img-fluid mx-2 partner-nav-img"
                                                        />
                                                    </a>
                                                </li>
                                            </ul>
                                            <ul className="beginner-design-part">
                                                <li>
                                                    <a className="dropdown-item" href="#" />
                                                </li>
                                                <li>
                                                    <Link
                                                        href={'/introducing-broker-program'}
                                                        className="dropdown-item"
                                                    >
                                                        Introducing broker
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>

                                    <li className="nav-item dropdown">
                                        <span
                                            className="nav-link dropdown-toggle"
                                            data-bs-toggle="dropdown"
                                            id="navbarDropdown"
                                            role="button"
                                            aria-expanded="false"
                                        >
                                            Platform
                                        </span>
                                        <div className="dropdown-menu mainmenus"
                                            aria-labelledby="navbarDropdown">

                                            <ul>
                                                <li>
                                                    <a href="/millance5setup.exe" download>
                                                        <span className="dropdown-item">
                                                            MT-Desktop
                                                        </span>
                                                    </a>
                                                </li>
                                                <li>
                                                    <Link href={'https://download.mql5.com/cdn/mobile/mt5/android?server=Millance-Server'} target="_blank">
                                                        <span className="dropdown-item">
                                                            MT-Android
                                                        </span>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link href={'https://download.mql5.com/cdn/mobile/mt5/ios?server=Millance-Server'} target="_blank">
                                                        <span className="dropdown-item">
                                                            MT-iPhone
                                                        </span>
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>
                                    <li className="nav-item dropdown">
                                        <span
                                            className="nav-link dropdown-toggle"
                                            data-bs-toggle="dropdown"
                                            id="navbarDropdown"
                                            role="button"
                                            aria-expanded="false"
                                        >
                                            Millance Tools
                                        </span>
                                        <div
                                            className="dropdown-menu mainmenus"
                                            aria-labelledby="navbarDropdown"
                                        >
                                            <ul>
                                                <li className="open-demo-but">
                                                    <a className="dropdown-item" href="#">
                                                        <img
                                                            src={"/images/home/mega-ico3.png"}
                                                            style={{ width: "300px", height: "100%" }}
                                                            alt="logo"
                                                            className="img-fluid mx-2 partner-nav-img1"
                                                        />
                                                    </a>
                                                </li>
                                            </ul>
                                            <ul className="beginner-design-part">
                                                <li>
                                                    <a className="dropdown-item" href="#" />
                                                </li>
                                                <li>
                                                    <Link
                                                        href={'/pamm-account'}
                                                        className="dropdown-item"
                                                    >
                                                        PAMM
                                                    </Link>
                                                </li>

                                                <li>
                                                    <Link
                                                        href={'/copy-trade'}
                                                        className="dropdown-item"
                                                    >
                                                        Copy Trade
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>
                                    <li className="nav-item dropdown">
                                        <span
                                            className="nav-link dropdown-toggle"
                                            data-bs-toggle="dropdown"
                                            id="navbarDropdown"
                                            role="button"
                                            aria-expanded="false"
                                        >
                                            Client Support
                                        </span>

                                        <div
                                            className="dropdown-menu mainmenus"
                                            aria-labelledby="navbarDropdown"
                                        >
                                            <ul className="campaign-des">
                                                <li className="open-demo-but">
                                                    <a className="dropdown-item" href="#">
                                                        <img
                                                            src={"/images/home/mega-ico5.png"}
                                                            style={{ width: "300px", height: "100%" }}
                                                            alt="logo"
                                                            className="img-fluid mx-2 partner-nav-img3"
                                                        />
                                                    </a>
                                                </li>
                                            </ul>

                                            <ul className="beginner-design">
                                                <li>
                                                    <a className="dropdown-item" href="#"></a>
                                                </li>
                                                <li>
                                                    <Link
                                                        href={'/about-us'}
                                                        className="dropdown-item">
                                                        About us
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link
                                                        href={'/why-choose-millance'}
                                                        className="dropdown-item"
                                                    >
                                                        Why choose us
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link
                                                        href={'/contact-us'}
                                                        className="dropdown-item"
                                                    >
                                                        Contact us
                                                    </Link>
                                                </li>

                                                <li>
                                                    <Link
                                                        href={'/legal-documents'}
                                                        className="dropdown-item"
                                                    >
                                                        Regulations and License
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>

                                </ul>
                                <div className="offcanvas2">
                                    <ul className="navbar-nav ms-auto mb-2 mt-1 mb-lg-0 d-flex">
                                        <li className="nav-item">
                                            <Link
                                                href="https://crm.millance.com/register"
                                                className="nav-link opacc"
                                                target="_blank"
                                            >
                                                Open Account
                                            </Link>
                                            <div className="sidebaroffcanvas">
                                                <Offcanvas show={show1} onHide={handleClose1} className="sidebaroffcanvas" placement="end">
                                                    <Offcanvas.Header closeButton>
                                                        <Offcanvas.Title>Register Account</Offcanvas.Title>
                                                    </Offcanvas.Header>
                                                    <Offcanvas.Body>
                                                        <div className="millilogin">
                                                            <form>
                                                                <div className="cltname mb-3">
                                                                    <label htmlFor="exampleInputName" className="form-label">Username</label>
                                                                    <input type="text" className="form-control" id="exampleInputName" aria-describedby="emailHelp" placeholder="Enter Your Email Address" />

                                                                </div>
                                                                <div className="mb-3">
                                                                    <label htmlFor="exampleInputEmail1" className="form-label">Email address</label>
                                                                    <input type="email" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />

                                                                </div>
                                                                <div className="col-md-12 col-lg-12 mb-3">
                                                                    <div className="row">
                                                                        <div className="col-md-12 col-lg-4">
                                                                            <label htmlFor="exampleInputName" className="form-label">Country</label>
                                                                            <select className="form-select" aria-label="Default select example">
                                                                                <option selected>Open this select menu</option>
                                                                                <option value="1">One</option>
                                                                                <option value="2">Two</option>
                                                                                <option value="3">Three</option>
                                                                            </select>
                                                                        </div>
                                                                        <div className="col-md-12 col-lg-8">
                                                                            <div className="">
                                                                                <label htmlFor="exampleInputNumber" className="form-label">Phone Number</label>
                                                                                <input type="number" className="form-control" id="exampleInputNumber" aria-describedby="emailHelp" />

                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="cltname mb-3">
                                                                    <label htmlFor="exampleInputPassword1" className="form-label">Password</label>
                                                                    <input type="password" className="form-control mb-2" id="exampleInputPassword1" placeholder="Enter Your Password" />
                                                                    <small>Note: Do not share your password to anyone.</small>
                                                                </div>
                                                                <div className="referclt mb-3">
                                                                    <a className="" onClick={() => {
                                                                        if (showdata2 === true) {
                                                                            setShowdata2(false)
                                                                        } else {
                                                                            setShowdata2(true)
                                                                        }
                                                                    }}>  <label className='form-label fs-6'> Referral (Optional) </label>
                                                                        <span className=" text-primary" id="inputGroupPrepend" style={{ cursor: "pointer" }} >
                                                                            <i className='fa fa-angle-down' style={{ fontSize: "20px", float: "right" }} ></i>
                                                                        </span></a>
                                                                    {showdata2 ?
                                                                        <div className=''>
                                                                            <input type="text" className='form-control mb-3 mt-0' placeholder="Enter your Referral Code" />

                                                                        </div> : ""}
                                                                </div>
                                                                <div className="form-check">
                                                                    <input className="form-check-input" type="checkbox" defaultValue id="flexCheckDefault" />
                                                                    <label className="form-check-label" htmlFor="flexCheckDefault">
                                                                        Terms and Conditions
                                                                    </label>
                                                                </div>
                                                            </form>
                                                            <div className="millibtn mt-3 mb-3">
                                                                <button type="button" className="btn">Register Now</button>
                                                            </div>
                                                            <div className="d-flex justify-content-start millinlinks">
                                                                <div className="fogot">
                                                                    <Link href="https://crm.millance.com/login"
                                                                        target="_blank">Already Account?</Link>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Offcanvas.Body>
                                                </Offcanvas>
                                            </div>
                                        </li>
                                        <li className="nav-item hhhh">
                                            <Link
                                                className="nav-link signin"
                                                href="https://crm.millance.com/login"
                                                target="_blank"
                                            >
                                                Sign in
                                            </Link>

                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </div>
    );
}
